const HomeIcon = ({
  width = 24,
  height = 24,
  color = "currentColor",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 700 700"
    fill={color}
    {...props}
  >
    <path d="M624.73 628.5h-119a61.69 61.69 0 0 1-61.62-61.62v-66.46a.32.32 0 0 0-.32-.31H366a.32.32 0 0 0-.32.31v66.46a61.69 61.69 0 0 1-61.62 61.62h-119a61.69 61.69 0 0 1-61.62-61.62V351.14a78.5 78.5 0 0 1 23.16-55.9L346.26 95.79a83.1 83.1 0 0 1 117.34 0l199.59 199.45a78.5 78.5 0 0 1 23.16 55.9v215.74a61.69 61.69 0 0 1-61.62 61.62zM366 470.11h77.8a30.36 30.36 0 0 1 30.32 30.31v66.46a31.65 31.65 0 0 0 31.62 31.62h119a31.65 31.65 0 0 0 31.62-31.62V351.14A48.7 48.7 0 0 0 642 316.46L442.4 117a53.09 53.09 0 0 0-74.94 0L167.88 316.46a48.7 48.7 0 0 0-14.37 34.68v215.74a31.65 31.65 0 0 0 31.62 31.62h119a31.65 31.65 0 0 0 31.62-31.62v-66.46A30.35 30.35 0 0 1 366 470.11z" />
  </svg>
);

export default HomeIcon;
